:host {
  --checker-background: var(--uui-theme-variant-100);
  --checker-light: 25%;
  --checker-dark: 75%;
  --checker-color: var(--uui-theme-variant-700);
  --checker-size: 30px;
  --checker-offset: calc(var(--checker-size) / 2);
}

uui-themed-background,
:host {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

div {
  position: relative;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

div.checkered {
  background-image: linear-gradient(
      45deg,
      var(--checker-color) var(--checker-light),
      transparent var(--checker-light)
    ),
    linear-gradient(
      -45deg,
      var(--checker-color) var(--checker-light),
      transparent var(--checker-light)
    ),
    linear-gradient(
      45deg,
      transparent var(--checker-dark),
      var(--checker-color) var(--checker-dark)
    ),
    linear-gradient(
      -45deg,
      transparent var(--checker-dark),
      var(--checker-color) var(--checker-dark)
    );
  background-size: var(--checker-size) var(--checker-size);
  background-position: 0 0, 0 var(--checker-offset),
    var(--checker-offset) calc(-1 * var(--checker-offset)),
    calc(-1 * var(--checker-offset)) 0;
  background-color: var(--checker-background);
}

[data-theme="inverse"] {
  --checker-background: var(--uui-theme-variant-100);
  --checker-color: var(--uui-theme-variant-100);
}
